module.exports = __webpack_public_path__ + "img/peace-justice-and-strong-institutions.ee291ae4.png";